import React from 'react'
import styled from 'styled-components'
import {WINDOW_MODE_MOBILE_WIDTH} from 'consts'
import {usePackageMetrics} from 'utils'
import {Paragraph, PackageIcon, Icon} from 'common/components'
import convertUnit from 'lib/unit'
import {useTranslation} from 'i18n'
import {TransactionDetailPackageItemSellerProps} from './TransactionDetailPackageItemSellerProps'

const StyledItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${convertUnit(80)};
  min-height: ${convertUnit(80)};
`

const StyledItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: ${convertUnit(5)};
  max-width: ${convertUnit(400)};
  @media (max-width: ${WINDOW_MODE_MOBILE_WIDTH}px) {
    max-width: 100%;
  }
`

const StyledGridPhoto = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: ${convertUnit(15)};
`

const StyledItemEnd = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-self: start;
  gap: ${convertUnit(4)};
`

const StyledOverflowParagraph = styled(Paragraph)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  overflow-wrap: anywhere;
`

export default function TransactionDetailPackageItemSeller({
  content,
  onClickItem,
}: TransactionDetailPackageItemSellerProps) {
  const {tree_name} = content
  const {translate} = useTranslation()
  const {packageIsActive, timeLeft} = usePackageMetrics(content)

  return (
    <StyledItemContainer
      onClick={onClickItem}
      style={{
        cursor: onClickItem ? 'pointer' : undefined,
      }}>
      <StyledGridPhoto>
        <PackageIcon />
      </StyledGridPhoto>
      <StyledItem>
        <StyledItemEnd>
          {packageIsActive ? (
            <>
              <Paragraph fontSize="s" fontWeight="bold" color="gray_4">
                {translate('giftShop:checkoutTimeLeft')}
              </Paragraph>
              <Icon size={16} type="clock" color="warning_4" />
              <Paragraph fontSize="s" fontWeight="bold" color="warning_4">
                {timeLeft}
              </Paragraph>
            </>
          ) : (
            <>
              <Icon size={16} type="clock" color="gray_4" />
              <Paragraph fontSize="s" fontWeight="bold" color="gray_4">
                {translate('global:expired')}
              </Paragraph>
            </>
          )}
        </StyledItemEnd>
        <StyledOverflowParagraph
          fontWeight="bold"
          color="black_1"
          fontSize="m"
          lineHeight={24}>
          {tree_name}
        </StyledOverflowParagraph>
      </StyledItem>
    </StyledItemContainer>
  )
}
